import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import NavBar from "@/components/NavBar";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import CasePage from "@/pages/CasePage";
import PricingPage from "@/pages/PricingPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import GuardianConsentPage from "@/pages/GuardianConsentPage";
import GuardianDashboardPage from "@/pages/GuardianDashboardPage";
import JoinPage from "@/pages/JoinPage";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--bg-base)]">
      <NavBar />
      <main className="flex-1">{children}</main>
      <footer className="text-center text-xs text-[color:var(--text-muted)] py-8 border-t border-[color:var(--line)] mt-12">
        FairResolver · structured conversations, equal voice.
      </footer>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback fragment synchronously (do not depend on useEffect timing)
  if (location.hash?.includes("session_id=")) {
    return (
      <Shell>
        <AuthCallback />
      </Shell>
    );
  }
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/consent/:token" element={<GuardianConsentPage />} />
        <Route path="/guardian/:token" element={<GuardianDashboardPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cases/:id"
          element={
            <ProtectedRoute>
              <CasePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
